import { selfAxios } from "../../../../../axios/selfAxios.js";
async function getSimpleOrderTaskInfoFun(params) {
  const { data } = await selfAxios.post(`/designapi/design/retailOrder/getSimpleOrderTaskInfo`, params);
  return data;
}
export { getSimpleOrderTaskInfoFun };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/retailOrder/getSimpleOrderTaskInfo/post.js